<template>
  <div>
    <GlobalInfoBar>
      条款协议
    </GlobalInfoBar>
    <GlobalChunk :padding="[20, 20, 20, 20]">
      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="tableData" :isPagination='false'>
        <el-table-column label="操作" slot="operation" align="center" width="300">
          <template slot-scope="{ row }">
            <el-button type="text" @click="edit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>
    <el-dialog title="编辑协议" :visible.sync="visible" width="90%" :before-close="dialogClose">
      <div>
        <vue-editor v-model="content" />
      </div>
      <div style="display: flex;justify-content: end;padding: 30px;">
        <el-button @click="dialogClose()">取消</el-button>
        <el-button type="primary" @click="submit()">确定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>


import {
  agreement, agreementEdit, agreementInfo
} from "@/utils/request/membershipSystem";
import { VueEditor } from 'vue2-editor';

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      tableColumns: [
        { label: "协议名称", prop: "title" },
        { slotName: "operation" },
        { label: "最新更新人", prop: "user_name" },
        { label: "最新更新时间", prop: "add_time" },
      ],
      tableData: [],
      visible: false,
      article_id: 0,
      content: ''
    }
  },
  mounted() {
    this.agreement()

  },

  methods: {

    agreement() {
      agreement({
        page: this.curPage,
      }).then(res => {
        this.tableData = res.data || []
        this.total = res.count || 0
      })
    },


    edit(row) {
      console.log(row);
      const { article_id } = row
      this.article_id = article_id
      agreementInfo({
        article_id
      }).then(res => {
        this.content = res.data.content
      })
      this.visible = true
    },

    submit() {
      this.$alert(`是否确认编辑？`, '确认弹窗', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            agreementEdit({
              article_id: this.article_id,
              content: this.content
            }).then(res => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.dialogClose()
            })
          }
        }
      });


    },
    dialogClose() {
      this.agreement()
      this.visible = false
    },
  }
}
</script>

<style scoped lang="scss"></style>